import {createSelector} from '@ngrx/store';
import {appRoleEntityAdapter as EntityAdapter, AppRoleState as EntityState} from "./app-role.state";
import {AppRole as Entity} from './app-role.model';
import {AppState} from "src/app/store/app-store.state";

export const selectState = (state: AppState) => state.appRole;

export const selectAll = createSelector(selectState, EntityAdapter.getSelectors().selectAll);

export const selectById = (entityId: number) =>
    createSelector(selectAll, (entities: Entity[]) => entities.find(p => p.id === entityId));

export const isLoading = createSelector(selectState, (state: EntityState) => state.isLoading);

export const hasErrors = createSelector(selectState, (state: EntityState) => state.error);

export const findByCorrelationId = <T>(correlationId: string) => createSelector(
    selectState,
    (state: EntityState) => <T>state.history.find(h => h.correlationId === correlationId)?.payload
);

export const currentEntity = createSelector(selectState, (state: EntityState) => state.currentEntity);

export const totalPageable = createSelector(selectState, (state: EntityState) => state.currentPage.totalCount);
export const currentPage = createSelector(selectState, (state: EntityState) => state.currentPage.page);
export const currentSort = createSelector(selectState, (state: EntityState) => state.currentSort);
export const AppRoleSelectors = {
    selectAll,
    selectById,
    isLoading,
    hasErrors,
    findByCorrelationId,
    currentEntity,
    totalPageable,
    currentPage,
    currentSort
};
